export default __webpack_public_path__ + "maps-examples-view-annotation-basic-960-4c7b92f86722f3bc4d7f9adaa0e94356.png";